; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/PictureHighlight',["picturefill"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("picturefill")) :
    console && console.error('Picture does not support non-amd script loading.');
}(this/* window */, function (picturefill) {

    // Loads picturefill.js to support <picture> tag in IE

}));
